// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".inner-circle[data-v-3d329f4e]{animation:spin-3d329f4e .8s linear infinite}.loader-label[data-v-3d329f4e]{border-width:0;clip:rect(0,0,0,0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px}@keyframes spin-3d329f4e{to{transform:rotate(1turn)}}@media(prefers-reduced-motion:reduce){.inner-circle[data-v-3d329f4e]{animation-duration:2.4s}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
